import { ofetch } from 'ofetch';

document.addEventListener('DOMContentLoaded', () => {
  const defaultPerPage = 20;
  const defaultInitialOffset = 10;

  function buildArgString(): string {
    let argstring = '';

    // Origin
    const originInput = document.getElementById('origin') as HTMLInputElement | null;
    const origin = originInput?.value || 'blog';
    argstring += `&origin=${origin}`;

    // Tag
    const tagInput = document.getElementById('tag') as HTMLInputElement | null;
    if (tagInput) {
      argstring += `&tag=${tagInput.value}`;
    }

    // Topic
    const topicInput = document.getElementById('topic') as HTMLInputElement | null;
    if (topicInput) {
      argstring += `&topic=${topicInput.value}`;
    }

    return argstring;
  }

  function getPageNumber(): number {
    const pageInput = document.getElementById('pageNum') as HTMLInputElement | null;
    const page = pageInput ? parseInt(pageInput.value, 10) : 1;
    return isNaN(page) ? 1 : page;
  }

  async function checkLoadMore(
    page: number = 1,
    initialOffset: number = defaultInitialOffset
  ): Promise<void> {
    const argstring = buildArgString();
    try {
      const returnedCount = await ofetch<string>(`/get_post_count?check_count=true${argstring}`);
      const countInt = parseInt(returnedCount, 10);

      if (
        (page === 1 && countInt < 11) ||
        (page >= 2 && countInt < page * defaultPerPage - initialOffset)
      ) {
        document.querySelectorAll<HTMLElement>('.load_more_button').forEach(btn => {
          btn.style.display = 'none';
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error checking load more:', err);
    }
  }

  // Initial check
  if (document.getElementsByClassName('load_more_button').length) {
    checkLoadMore();
  }

  // Click handler
  document.querySelectorAll<HTMLElement>('.load_more_button').forEach(button => {
    button.addEventListener('click', async () => {
      // Show spinner
      document.querySelectorAll<HTMLElement>('.load_more_animation').forEach(el => {
        el.style.display = 'block';
      });

      let page = getPageNumber();
      const argstring = buildArgString();

      const originInput = document.getElementById('origin') as HTMLInputElement | null;
      const origin = originInput?.value || 'blog';
      const classname = origin === 'library' ? 'library-list-item' : 'blog-list-item';

      const posts = document.getElementsByClassName(classname);
      const lastPost = posts[posts.length - 1] as HTMLElement | undefined;

      try {
        const html = await ofetch<string>(
          `/get_posts_html?offset=10&page=${page}${argstring}`
        );

        page += 1;
        const pageInput = document.getElementById('pageNum') as HTMLInputElement | null;
        if (pageInput) pageInput.value = String(page);

        // Hide spinner
        document.querySelectorAll<HTMLElement>('.load_more_animation').forEach(el => {
          el.style.display = 'none';
        });

        // Append new posts
        const postList = document.querySelector('.post_list');
        if (postList) {
          postList.insertAdjacentHTML('beforeend', html);
        }

        // Scroll into view
        if (lastPost) {
          lastPost.scrollIntoView();
        }

        // Re-check load more
        checkLoadMore(page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error loading posts:', err);
      }
    });
  });
});
